import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import LabTestBody from "components/ClinicalManagement/LabTest/LabTestBody";

const LabTest = () => {
  useEffect(() => {
    document.title = "Lab Test";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <LabTestBody />
    </main>
  );
};

export default LabTest;
